module.exports = __webpack_public_path__ + "static/media/publishers.d30fb0f9.webp";